export default __webpack_public_path__ + "static/media/cards-graphic1.4dfb2e1b.svg";